export default {
    anfaelle: state => state.anfaelle
}